import { StyledContainer, StyledEmptyMessageContainer, StyledEmptyText, StyledEmptyIcon } from './styled-components'

import IconLocationCompany from '@/shared/icons/NewDesign/IconLocationCompany'
import useDistributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/useDistributor'
import DistributorEmptyMessage from '@/containers/SubscriptionFormPageNew/Components/Distributor/DistributorEmptyMessage'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import { ModuleContent } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'

const DistributorEmpty = () => {
  const { t, address } = useDistributor()
  const { expanded, toggle } = useModuleCollapse('distributor')
  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconLocationCompany} moduleKey='distributor'>
          {t('subscriptionForm:distributor.title')}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='distributor' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <StyledEmptyMessageContainer>
          <StyledEmptyIcon>
            <IconLocationCompany size={60} defaultColorKey='borderInput' />
          </StyledEmptyIcon>
          <StyledEmptyText>
            <DistributorEmptyMessage address={address} />
          </StyledEmptyText>
        </StyledEmptyMessageContainer>
      </ModuleContent>
    </StyledContainer>
  )
}

export default DistributorEmpty
